<!--
  Page shell: optional titled subnav + content slot.
  fullwidth + title → edge-to-edge table with pt-8 under subnav;
  fullwidth without title (e.g. Settings) stays flush under the main nav.
-->
<template>
  <div>
    <v-container
      fluid
      class="main-view"
    >
      <v-row>
        <v-col
          v-if="title"
          cols="12"
          class="pa-0"
        >
          <base-view-header :title="title">
            <template #filters="props">
              <slot name="filters" v-bind="props" />
            </template>
            <template #actions="props">
              <slot name="actions" v-bind="props" />
            </template>
          </base-view-header>
        </v-col>
        <v-col
          v-if="dense"
          cols="12"
          :class="contentColClass"
        >
          <v-container>
            <slot></slot>
          </v-container>
          <base-error-alerts></base-error-alerts>
        </v-col>
        <v-col
          v-else
          cols="12"
          :class="contentColClass"
        >
          <slot></slot>
          <base-error-alerts></base-error-alerts>
        </v-col>
      </v-row>
    </v-container>
    <slot name="other"></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseViewContainer',

  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: '',
    },
    fullwidth: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    /**
     * Fullwidth + titled subnav: keep horizontal bleed but restore pt-8 between
     * subnav and table (Vuetify 3 pa-0 left them flush). Fullwidth without a title
     * (e.g. Settings tabs) stays flush under the main nav like master.
     */
    contentColClass() {
      if (this.fullwidth) {
        return this.title ? 'px-0 pb-0 pt-8' : 'pa-0';
      }
      if (this.dense) {
        return 'pt-8';
      }
      return 'pt-8 px-16';
    },
  },
};
</script>

<style scoped>
.main-view {
  min-height: 100vh !important;
  min-height: calc(100vh - 48px) !important;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
}
</style>
